module.exports = __webpack_public_path__ + "static/img/16.bd17e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cooperate/16.png
// module id = 3ato
// module chunks = 1